/**
 * Forms rendered inside cached fragments carry a CSRF token shared across sessions, hence invalid.
 * Fetch a fresh one right before submission (input flagged with data-csrf-refresh).
 * Never rejects: on failure the stale token is kept and the server rejects the request as before.
 * @param {HTMLFormElement} form the form being submitted
 * @returns {Promise<void>} resolved once the token input is up to date
 */
const refreshCsrfToken = function (form) {
    const input = form.querySelector('[data-csrf-refresh]');
    const refreshUrl = input && input.dataset.csrfRefreshUrl;
    if (!refreshUrl) return Promise.resolve();

    return fetch(refreshUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.json();
        })
        .then((data) => {
            input.name = data.tokenName;
            input.value = data.token;
        })
        .catch(() => {});
};

export default { refreshCsrfToken };
